"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;


































































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _Intention = _interopRequireDefault(require("@/components/Intention"));
var _DeviceType = _interopRequireDefault(require("@/components/DeviceType")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { Intention: _Intention.default, Device: _DeviceType.default }, data: function data() {return { tableData: [], // 列表数据
      organizationList: [], robotId: '', insId: '', newadd: false, modOrg: false, title: '', detail: '', searchData: { deviceTypeCode: '', standardSlot: '', intentCode: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', cmdContent: '', deviceTypeId: 0, intentId: 0, intentCode: '', standardSlot: '', remark: '' }, rules: { deviceTypeId: [{ required: true, message: '请输入设备类型', trigger: 'blur' }], intentCode: [{ required: true, message: '请输入意图', trigger: 'blur' }], cmdContent: [{ required: true, message: '请输入命令', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'deviceTypeCode', label: '设备编码', isShow: true }, { prop: 'deviceTypeName', label: '设备名称', isShow: false }, { prop: 'intentCode', label: '意图编码', isShow: true }, { prop: 'standardSlot', label: '词槽', isShow: true }, { prop: 'cmdContent', label: '命令', isShow: true, width: '390' }, { prop: 'remark', label: '备注', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: false }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: false }], defaultProps: { children: 'child', label: 'insName' } };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/voiceFunction', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, getOrganziationList: function getOrganziationList() {var self = this;self.getData('/api/institution/dropList/0', {}, function (res) {self.organizationList = res;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.standardSlot = '';this.searchData.deviceTypeCode = '';this.searchData.intentCode = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    handleIntentionMsg: function handleIntentionMsg(intention) {
      var self = this;
      self.addData.intentCode = intention.intentCode;
      self.addData.intentId = intention.id;
      self.addData.standardSlot = intention.standardSlot;
      self.addData.slot = intention.slot;
    },
    handleSelectIntention: function handleSelectIntention() {
      this.$refs.intentionRef.handleShow = true;
    },
    handleDeviceMsg: function handleDeviceMsg(device) {
      var self = this;
      self.addData.deviceTypeCode = device.code;
      self.addData.deviceTypeId = device.id;
    },
    handleSelectDevice: function handleSelectDevice() {
      this.$refs.deviceRef.handleShow = true;
    },
    handleGetDetail: function handleGetDetail(id) {
      var self = this;
      self.getData('/api/voiceFunction/' + id, {}, function (res) {
        self.addData = res;
        self.addData.id = res.id;
        self.addData.cmdContent = res.cmdContent;
        self.addData.deviceTypeId = res.deviceTypeId;
        self.addData.deviceTypeCode = res.deviceTypeCode;
        self.addData.intentId = res.intentId;
        self.addData.intentCode = res.intentCode;
        self.addData.standardSlot = res.standardSlot;
        self.addData.remark = res.remark;
      });
    },

    addFun: function addFun() {// 新增
      this.title = '新增';
      this.newadd = true;
    },
    closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();
      this.cleanData();
      this.newadd = false;
      this.newadd2 = false;
    },
    updateMenu: function updateMenu(id) {// 修改操作
      this.title = '修改';
      var self = this;
      self.newadd = true;
      self.handleGetDetail(id);
      /* self.addData = {
                                  id: item.id,
                                  deviceTypeCode: item.deviceTypeCode,
                                  deviceTypeId: item.deviceTypeId,
                                  intentId: item.intentId,
                                  intentCode: item.intentCode,
                                  slot: item.slot,
                                  standardSlot: item.standardSlot,
                                  remark: item.remark,
                                  cmdContent: item.cmdContent
                                } */
    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/voiceFunction', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/voiceFunction/' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        intentCode: '',
        deviceTypeCode: '',
        deviceTypeId: 0,
        intentId: 0,
        cmdContent: '',
        standardSlot: '',
        slot: '',
        remark: '' };

    },
    openOrgDialog: function openOrgDialog(robotId) {
      var self = this;
      self.robotId = robotId;
      self.getIns(robotId);
      self.getOrganziationList();
      self.modOrg = true;
    },
    checkFn: function checkFn(node, data) {
      var currKey = node.id;
      this.$refs.orgTree.setCheckedKeys([currKey]);
      this.insId = currKey;
    } } };exports.default = _default;